import React from "react";
import { Checkbox, Row, Divider, Col } from "antd";
import "../Desktop/comboCheckbox.scss";

import { COMMON_CONSTANT, lang } from "../../constants/common.const";
import InfiniteScroll from "react-infinite-scroller";
import LoadingInline from "../Popup/loading-inline";

export default function ListItemIoT({
  options = [],
  checkedList = [],
  listFilter = [],
  checkAll,
  onCheck,
  onCheckAll,
  loadMore,
  ...other
}) {
  return (
    <div
    >
      {options.length > 0 ? (
        <div className="comboCheckboxRow" {...other}>
          {/* Select all */}
          <div className="checkbox-all">
            <Checkbox
              indeterminate={false}
              onChange={onCheckAll}
              checked={checkAll}
            >
              <b>{lang.ALL}</b>
            </Checkbox>
          </div>
          {/* Select option */}
          <div className="checkbox-list">
            {options.map((o, index) => {
              let checked = false,
                added = false;
              (checkedList || []).forEach((obj) => {
                if (obj[o.channelKey]) {
                  checked = true;
                }
              });
              listFilter.forEach((code) => {
                if (
                  String(o.channelKey) ===
                  String(code.channelKey)
                ) {
                  added = true;
                }
              });

              return (
                <div key={index}>
                  <label className={"m " + (added ? "chooseMachine" : "")}>
                    <div className="m-title d-flex">
                      <Checkbox
                        onChange={(e) => {
                          // Checked
                          if (e.target.checked) {
                            const obj = {};
                            obj[o.channelKey] = o;
                            checkedList.push(obj);
                          } else {
                            // Uncheck
                            // Delete option
                            checkedList = checkedList.filter((obj) => {
                              return !obj[o.channelKey];
                            });
                          }
                          // Update state
                          onCheck(checkedList);
                        }}
                        checked={checked || added}
                        disabled={added}
                      />
                      <Row
                        justify="space-between"
                        className="align-center w100 ml5"
                      >
                        <Col className={"bold"}>
                          {o.checkItemName}
                        </Col>
                        <Col>{added ? lang.ADDED : lang.NOT_ADDED}</Col>
                      </Row>
                    </div>
                  </label>
                  <Divider className="m-space" />
                </div>
              );
            })}
          </div>
          <div className="content-center w100">
           
          </div>
        </div>
      ) : (
        <div style={{
            textAlign:"center"
        }}>{COMMON_CONSTANT.EMPTY_DATA}</div>
      )}
    </div>
  );
}
